import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Col, notification, Row, Select, Skeleton, Spin } from 'antd';
import axios from 'axios';
import './assets/css/article.css';
import fish from './assets/images/fish.png';
import user from './assets/images/user.svg';
import calendar from './assets/images/calendar-article.svg';
import checklist from './assets/images/checklist.svg';
import magnifier from './assets/images/magnifier.svg';
import eye from './assets/images/grey-eye.svg';
import noArticle from './assets/images/no-article.svg';

import { Helmet } from 'react-helmet';

import ViewArticle from './components/Article';
import PaginateBack from './assets/images/paginateBack';
import PaginateNext from './assets/images/paginateNext';

const imagePaths = {
  exotic: require('../home/assets/images/Exotic-image.png'),
  specimen: require('../home/assets/images/specimen-image.png'),
  thailand: require('../home/assets/images/Europe-image.png'),
  europe: require('../home/assets/images/Thailand-image.png'),
  pleasure: require('../home/assets/images/Pleasure-lake-image.png'),
  appLake: require('../home/assets/images/app-lake-placeholder.png'),
  checked: require('../home/assets/images/checked-bullet.svg').default,
  appQR: require('../home/assets/images/AppDownload.svg').default,
  appStoreIcon:
    require('../common/assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg')
      .default,
  googlePlayIcon: require('../common/assets/images/google-play-badge.png'),
};
export default function Articles() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [paginateLoading, setpaginateLoading] = useState(false);
  const [fullArticleData, setFullArticleData] = useState(null);
  const [articleData, setArticleData] = useState(null);
  const [articleDetailPage, setArticleDetailPage] = useState(false);

  const [selectedCategory, setselectedCategory] = useState('All');
  let article_id = useParams()['article_id'];
  useEffect(() => {
    if (article_id) {
      setArticleDetailPage(true);
    }
  }, [article_id]);
  const getArticles = () => {
    axios
      .get('social')
      .then((res) => {
        if (res.status === 200) {
          let result = res.data.result;
          setFullArticleData(result);
          setArticleData(result.all);
          setLoading(false);
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing request',
          });
        }
      })
      .catch(() => {
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Error processing request',
        });
      })
      .finally(() => {});
  };
  let latestArticle = articleData ? articleData[0] : null;
  let paginateArticles = articleData ? articleData?.slice(1) : [];
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState([]);

  const totalPages = Math.ceil(paginateArticles?.length / 6);
  useEffect(() => {
    setCurrentPage(1);
    console.log(paginateArticles);
    setCurrentItems(paginateArticles?.slice(0, 6));
  }, [articleData]);
  const getPageRange = () => {
    const start = Math.max(1, currentPage - 2); // Show two pages before current page
    const end = Math.min(totalPages, start + 4); // Show up to five pages in total
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const handlePageChange = (page) => {
    setpaginateLoading(true);
    setCurrentItems(paginateArticles?.slice((page - 1) * 6, page * 6));
    setCurrentPage(page);

    const element = document.getElementById('paginate-article');

    const offset = 100; // Space you want at the top
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
    setTimeout(() => {
      setpaginateLoading(false);
    }, 600);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    getArticles();
  }, []);
  const CategoryOption = [
    { value: 'All', label: 'All' },
    { value: 'Giveaways', label: 'Giveaways' },
    { value: 'Reviews', label: 'Reviews' },
    { value: 'swimbooker+', label: 'swimbooker+' },
    { value: 'News', label: 'News' },
    { value: 'Education', label: 'Education' },
    { value: 'Tech', label: 'Tech' },
    { value: 'Spotlight', label: 'Spotlight' },
    { value: 'Fishery', label: 'Fishery' },
  ];
  function handleCategory(category) {
    setselectedCategory(category);
    setArticleDetailPage(false);
    history.push('/articles');
    switch (category) {
      case 'All':
        setArticleData(fullArticleData?.all);
        break;

      case 'Giveaways':
        setArticleData(fullArticleData?.giveaways);
        break;

      case 'Reviews':
        setArticleData(fullArticleData?.reviews);
        break;

      case 'swimbooker+':
        setArticleData(fullArticleData?.['swimbooker+']);
        break;

      case 'News':
        setArticleData(fullArticleData?.news);
        break;

      case 'Education':
        setArticleData(fullArticleData?.education);
        break;

      case 'Tech':
        setArticleData(fullArticleData?.tech);
        break;

      case 'Spotlight':
        setArticleData(fullArticleData?.spotlight);
        break;

      case 'Fishery':
        setArticleData(fullArticleData?.fishery);
        break;

      default:
        console.log('Unknown category');
        break;
    }
  }
  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <meta
          name='description'
          content='Angling Information, fishing tips & tricks, tackle giveaways and angling competitions. All available via swimbooker’s angling social.'
        />
        <title>
          The Best Place For Fishing Information & Articles | swimbooker Angling
          Social
        </title>
      </Helmet>
      <div className='main_container_padding__content w-full'>
        <Row>
          <Col className='gutter-row' span={24}>
            <div className='articles-page-masthead'>
              <div className='articles-page-masthead__content'>
                <div className='center'>
                  <img
                    src={fish}
                    width={52}
                    height={32}
                    alt='fish'
                    className=' mg-bottom-15'
                  />
                </div>
                <h1 className='articles-page-masthead__title white gBold mg-bottom-20'>
                  The Angling Social <span className='gRegular'>Blog</span>
                </h1>
                <div className='articles-page-masthead__paragraph txt-center gSemiBold    '>
                  The latest{' '}
                  <span className='gBold white'>
                    swimbooker updates, industry news
                  </span>{' '}
                  and <span className='gBold white'>educational content </span>
                  in one place!
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className='' style={{ width: '90%', margin: 'auto' }}>
          <div className='article-category mg-bottom-50'>
            <div className='justify-around desktop-version row-center row-gap-1r flex-wrap'>
              <Col
                className={`${selectedCategory == 'All' ? 'active' : ''} nav`}
                onClick={() => {
                  handleCategory('All');
                }}
              >
                {' '}
                All
              </Col>
              <Col
                className={`${
                  selectedCategory == 'Giveaways' ? 'active' : ''
                } nav`}
                onClick={() => {
                  handleCategory('Giveaways');
                }}
              >
                {' '}
                Giveaways
              </Col>
              <Col
                className={`${
                  selectedCategory == 'Reviews' ? 'active' : ''
                } nav`}
                onClick={() => {
                  handleCategory('Reviews');
                }}
              >
                {' '}
                Reviews
              </Col>
              <Col
                className={`${
                  selectedCategory == 'swimbooker+' ? 'active' : ''
                } nav`}
                onClick={() => {
                  handleCategory('swimbooker+');
                }}
              >
                {' '}
                swimbooker+
              </Col>
              <Col
                className={`${selectedCategory == 'News' ? 'active' : ''} nav`}
                onClick={() => {
                  handleCategory('News');
                }}
              >
                {' '}
                News
              </Col>
              <Col
                className={`${
                  selectedCategory == 'Education' ? 'active' : ''
                } nav`}
                onClick={() => {
                  handleCategory('Education');
                }}
              >
                {' '}
                Education
              </Col>
              <Col
                className={`${selectedCategory == 'Tech' ? 'active' : ''} nav`}
                onClick={() => {
                  handleCategory('Tech');
                }}
              >
                {' '}
                Tech
              </Col>
              <Col
                className={`${
                  selectedCategory == 'Spotlight' ? 'active' : ''
                } nav`}
                onClick={() => {
                  handleCategory('Spotlight');
                }}
              >
                {' '}
                Spotlight
              </Col>
              <Col
                className={`${
                  selectedCategory == 'Fishery' ? 'active' : ''
                } nav`}
                onClick={() => {
                  handleCategory('Fishery');
                }}
              >
                {' '}
                Fishery
              </Col>
            </div>
            <div className='mobile-version center'>
              <div className='fs-22 gBold w-full grey-900 mg-bottom-10'>
                Category
              </div>
              <Select
                className='gSemiBold w-full grey-800'
                popupClassName='gSemiBold fs-16 grey-800'
                onSelect={(value) => {
                  handleCategory(value);
                }}
                value={selectedCategory}
                options={CategoryOption}
              />
            </div>
          </div>
        </div>
        {articleDetailPage ? (
          <div id='articles-content-wrapper'>
            <ViewArticle
              categoryArticles={articleData}
              setDetailsPage={setArticleDetailPage}
              category={selectedCategory}
            />
          </div>
        ) : (
          <>
            <div id='articles-content-wrapper'>
              {latestArticle || loading ? (
                loading ? (
                  <Row>
                    <Col className='gutter-row' span={24}>
                      <Row gutter={[35, 5]}>
                        <Col xs={24} md={24} lg={12}>
                          <Skeleton.Image
                            active={true}
                            className='w-full br20 h-full'
                          />
                        </Col>
                        <Col
                          xs={24}
                          md={24}
                          lg={12}
                          className='mg-top-20 mg-bottom-20'
                        >
                          <div className='gMedium fs-20 grey-500 mg-bottom-25'>
                            Latest
                          </div>
                          <Skeleton active className='mg-bottom-30' />
                          <div className='justify-between'>
                            <Skeleton.Input active />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col className='gutter-row' span={24}>
                      <Link
                        to={`/article/${latestArticle.id}`}
                        onClick={() => setArticleDetailPage(true)}
                      >
                        <Row
                          gutter={[35, 5]}
                          className='article-latest-container'
                        >
                          <Col xs={24} md={24} lg={12}>
                            <div
                              id='articles-page-secondary-image'
                              style={{
                                backgroundImage: `url(${latestArticle.image})`,
                              }}
                            >
                              <div id='article-landing-page-content-2' />
                            </div>
                          </Col>
                          <Col
                            xs={24}
                            md={24}
                            lg={12}
                            className='mg-top-20 mg-bottom-20'
                          >
                            <div className='gMedium fs-20 grey-500 mg-bottom-25'>
                              Latest
                            </div>

                            <div
                              className='gBold article-title  fs-40 mg-bottom-30'
                              style={{
                                lineHeight: 1.2,
                              }}
                            >
                              {latestArticle.title}
                            </div>
                            <div className='gMedium latest_article_preview fs-20  mg-bottom-30'>
                              {latestArticle.preview}
                            </div>

                            <div className='justify-between'>
                              <div className='fs-20 gSemiBold black'>
                                {latestArticle.author}
                              </div>
                              <div className='gSemiBold fs-20 grey-500 row-center'>
                                <img
                                  src={eye}
                                  alt='eye'
                                  className='mg-right-15'
                                />
                                {latestArticle?.read_time_mins}{' '}
                                {latestArticle?.read_time_mins > 1
                                  ? 'mins'
                                  : 'min'}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Link>
                    </Col>
                  </Row>
                )
              ) : (
                <div
                  className='mg-top-50 w-full center mg-auto justify-center'
                  style={{ maxWidth: 339 }}
                >
                  <img src={noArticle} alt='empty' className='mg-bottom-10' />
                  <div className='fs-24 gBold mg-bottom-10'>
                    No articles here!
                  </div>
                  <div className='fs-20 gMedium mg-bottom-20 grey-500 txt-center'>
                    Check back later for more updates or select a different
                    category above!
                  </div>
                </div>
              )}
              {loading || paginateLoading || paginateArticles.length ? (
                <>
                  <Row
                    gutter={[40, 50]}
                    id='paginate-article'
                    className='article-summary-container mg-top-50 mg-bottom-50'
                  >
                    {loading || paginateLoading
                      ? Array.from(
                          { length: 6 },
                          (_, i) => `Item ${i + 1}`
                        ).map(() => {
                          return (
                            <Col
                              xs={24}
                              md={12}
                              lg={8}
                              className='cp article-summary-wrapper'
                              onClick={() => {
                                // window.scrollTo(0, 0);
                              }}
                            >
                              <Skeleton.Image
                                active
                                className='img'
                                style={{ height: '100%' }}
                              />
                              <div className='fs-20 gMedium grey-600 mg-bottom-15'>
                                {selectedCategory}
                              </div>

                              <Skeleton
                                paragraph={3}
                                className='fs-20 gMedium  mg-bottom-15 '
                                active
                              />
                              <div className='justify-between'>
                                <Skeleton.Input active />
                              </div>
                            </Col>
                          );
                        })
                      : currentItems?.map((item, index) => {
                          return (
                            <Col
                              key={`article-${index}`}
                              xs={24}
                              sm={12}
                              md={12}
                              lg={8}
                              className='cp article-summary-wrapper'
                            >
                              <Link
                                to={`/article/${item.id}`}
                                onClick={() => setArticleDetailPage(true)}
                              >
                                <img
                                  className='img'
                                  src={item.image}
                                  alt='article-image'
                                />
                                <div className='fs-20 gMedium grey-500 mg-bottom-15'>
                                  {selectedCategory}
                                </div>
                                <div className='fs-24 gBold text-heading  mg-bottom-15'>
                                  {item?.title}
                                </div>
                                <div className='fs-20 gMedium  mg-bottom-15 preview-text'>
                                  {item?.preview}
                                </div>
                                <div className='justify-between'>
                                  <div className='fs-20 gSemiBold sb-black'>
                                    {item?.author}
                                  </div>
                                  <div className='fs-20 gSemiBold grey-500 row-center'>
                                    <img
                                      src={eye}
                                      alt='eye'
                                      className='mg-right-15'
                                    />
                                    <div className='row-center'>
                                      {item?.read_time_mins}{' '}
                                      {item?.read_time_mins > 1
                                        ? 'mins'
                                        : 'min'}
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </Col>
                          );
                        })}
                  </Row>

                  {getPageRange().length > 1 && (
                    <div
                      className='article-pagination-container '
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <div
                        onClick={() => {
                          if (currentPage !== 1) {
                            handlePageChange(currentPage - 1);
                          }
                        }}
                        className={`${currentPage !== 1 ? 'cp' : ''}`}
                        style={{
                          color: currentPage == 1 ? 'grey' : '#1F5B8C',
                        }}
                      >
                        <PaginateBack className='mg-right-15' />
                      </div>

                      {getPageRange().map((page) => (
                        <div
                          key={page}
                          onClick={() => handlePageChange(page)}
                          style={{
                            padding: '8px',
                          }}
                          className={`paginate-button ${
                            currentPage == page ? 'active' : ''
                          }`}
                        >
                          {page}
                        </div>
                      ))}

                      <div
                        onClick={() => {
                          if (currentPage !== totalPages) {
                            handlePageChange(currentPage + 1);
                          }
                        }}
                        disabled={currentPage === totalPages}
                        className={`${currentPage !== totalPages ? 'cp' : ''}`}
                        style={{
                          color: currentPage == totalPages ? 'grey' : '#1F5B8C',
                        }}
                      >
                        <PaginateNext className='mg-right-15' />
                      </div>
                    </div>
                  )}
                </>
              ) : (
                ''
              )}
            </div>
          </>
        )}

        <Col span={24} className='mg-bottom-100 other-pages-wrapper'>
          <div>
            <div
              className='gBold fs-40 mg-bottom-50 txt-center'
              style={{ color: 'rgba(31, 35, 38, 0.96)' }}
            >
              Where to next?...
            </div>
            <Row gutter={[0, 20]} className='justify-center mg-bottom-50'>
              <Link to='/user/signup' className='other-page-buttons '>
                <img src={user} alt='user' className='mg-right-10' />
                Create your account
              </Link>

              <Link to='/search' className='other-page-buttons '>
                <img src={calendar} alt='calendar' className='mg-right-10' />
                Find your next venue
              </Link>

              <a
                href={`${process.env.REACT_APP_SBPLUS_URL}/sign-up`}
                className='other-page-buttons '
              >
                <img src={magnifier} alt='magnifier' className='mg-right-10' />
                Explore swimbooker+
              </a>

              <Link
                to='/swimbooker-fishery-manager'
                className='other-page-buttons '
              >
                <img src={checklist} alt='checklist' className='mg-right-10' />
                List your lakes with us
              </Link>
            </Row>
          </div>
          <Row className='mobile-app-container'>
            <div className='img-container'>
              <img src={imagePaths.appLake} alt='lake-image' />
            </div>
            <div
              className='  justify-between'
              style={{
                flex: 1,
                flexDirection: 'column',
                padding: '20px 20px 15px ',
              }}
            >
              <div className='row-center flex-wrap'>
                <div className='benefits'>
                  <div className='fs-32 grey-900 gBold mg-bottom-20 text-center'>
                    Go further with the swimbooker app
                  </div>
                  <div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      Direct Notification Updates
                    </div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      MySB - Your Angler Hub
                    </div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      Advanced Catch Reports
                    </div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      Live Availability
                    </div>
                  </div>
                </div>
                <div className='QR'>
                  <img src={imagePaths.appQR} alt='app-qr' />
                </div>
                <div className='app-mobile-icons'>
                  <a
                    href={
                      'https://apps.apple.com/gb/app/swimbooker/id1586855906'
                    }
                    className={'sb-footer__app_link'}
                  >
                    <img
                      src={imagePaths.appStoreIcon}
                      alt={'Download on the App Store'}
                    />
                  </a>
                  <a
                    className={'sb-footer__app_link'}
                    href='https://play.google.com/store/apps/details?id=com.app.swimbookerapp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                  >
                    <img
                      src={imagePaths.googlePlayIcon}
                      alt='Get it on Google Play'
                    />
                  </a>
                </div>
              </div>
              <div className='gSemiBold fs-20 grey-900 text'>
                Scan the QR code with your device camera and download our app
              </div>
            </div>
          </Row>
        </Col>
      </div>
    </>
  );
}
